import {
  JOB_LIST,
  JOB_LIST_SUCCESSFUL,
  JOB_LIST_FAILED,
  JOB_SEARCH,
  JOB_SEARCH_SUCCESSFUL,
  JOB_SEARCH_FAILED,
  JOB_DISTRIBUTION,
  JOB_DISTRIBUTION_SUCCESSFUL,
  JOB_DISTRIBUTION_FAILED,
  GET_JOB_STATUS,
  GET_JOB_STATUS_SUCCESSFUL,
  GET_JOB_STATUS_FAILED,
  GET_MANAGE_LINK,
  GET_MANGE_LINK_SUCCESS,
  GET_MANGE_LINK_FAIL,
  JOB_DELETE,
  JOB_DELETE_FAILED,
  JOB_DELETE_SUCCESSFUL,
  GET_DATA,
  GET_SEARCH_DATA,
  GET_JOBS_BY_SEARCH,
  GET_JOBS_BY_LIST,
  GET_JOBS_BY_LIST_SUCCESS,
  GET_JOBS_BY_LIST_FAILED,
  GET_JOBS_BY_SEARCH_SUCCESS,
  GET_JOBS_BY_SEARCH_FAILED,
  GET_JOBS_BY_FILTER,
  GET_JOBS_BY_FILTER_FAILED,
  GET_JOBS_BY_FILTER_SUCCESS,
} from "./actionTypes"

const initialState = {
  jobListError: null,
  message: null,
  loading: false,
  loading2:false,
  user: null,
  searchList:null,
  jobDeleteSuccess:null,
  jobDeleteError:null,
  jobStatusData:null,
  jobId: null,
  jobStatusErrorMessage:null,
  distributionJobId:null,
  distributionSuccessMessage:null,
  distributionFailMessage: null,
  jobStatusLoader:false,
  jtJobId :null,
  mangeBtnLoader: false,
  mangeLinkData: null,
  mangeLinkDataErrorMessage:null,
  jobs:null,
  jobsFailed:null
}

const getJobList = (state = initialState, action) => {
  switch (action.type) {
    case JOB_LIST:
      state = {
        ...state,
        loading: true,
        jobListError: null
      }
      break
    case JOB_LIST_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        user: action.payload,
        jobListError: null,
      }
      break
    case JOB_LIST_FAILED:
     
      state = {
        ...state,
        user: null,
        loading: false,
        jobListError: action.payload,
      }
      break
      case JOB_SEARCH:
        state = {
          ...state,
          loading: true,
          jobSearchListError: null,
        }
        break
      case JOB_SEARCH_SUCCESSFUL:
        state = {
          ...state,
          loading: false,
          searchList: action.payload,
          jobSearchListError: null,
        }
        break
      case JOB_SEARCH_FAILED:
       
        state = {
          ...state,
          searchList: null,
          loading: false,
          jobSearchListError: action.payload,
        }
        break

      case JOB_DISTRIBUTION:  
      state = {
        ...state,
          loading: true,
          loading2:true,
          distributionJobId: action.payload,
          distributionSuccessMessage: null,
          distributionFailMessage:null
      }
      break
      case JOB_DISTRIBUTION_SUCCESSFUL:  
      state = {
        ...state,
          loading: false,
          loading2:false,
          distributionJobId:null,
          distributionSuccessMessage: action.payload,
          distributionFailMessage: null,
      }
      break
      case JOB_DISTRIBUTION_FAILED:  
      state = {
        ...state,
          loading: false,
          loading2:false,
          distributionJobId:null,
          distributionSuccessMessage: null,
          distributionFailMessage: action.payload,
      }
      break
      case GET_JOB_STATUS:
        state={
          ...state,
          loading:true,
          jobId: action.payload,
          jobStatusData:null,
          jobStatusErrorMessage:null,

        }
        break
        case GET_JOB_STATUS_SUCCESSFUL:
        state={
          ...state,
          loading:false,
          jobStatusData:action.payload,
          jobStatusErrorMessage:null,
          
        }
        break
        case GET_JOB_STATUS_FAILED:
        state={
          ...state,
          loading:false,
          jobStatusData:null,
          jobStatusErrorMessage:action.payload,

        }
        break
        case GET_MANAGE_LINK:
        state={
          ...state,
          loading:true,
          jtJobId : action.payload,
          mangeLinkData:null,
          mangeLinkDataErrorMessage:null,

        }
        break
       case GET_MANGE_LINK_SUCCESS:
       state={
        ...state,
        loading:false,
        jtJobId:null,
        mangeLinkData:action.payload,
        mangeLinkDataErrorMessage:null,
       }
       break

       case GET_MANGE_LINK_FAIL:
       state={
        ...state,
        loading:false,
        jtJobId:null,
        mangeLinkData:null,
        mangeLinkDataErrorMessage:action.payload,
       }
       break

        case JOB_DELETE:
          state = {
            ...state,
            loading: true,
            jobDeleteError: null,
            jobDeleteSuccess:null
          }
          break
        case JOB_DELETE_SUCCESSFUL:
          state = {
            ...state,
            loading: false,
            jobDeleteSuccess: action.payload,
            jobDeleteError: null,
          }
          break
        case  JOB_DELETE_FAILED:
         
          state = {
            ...state,
            jobDeleteSuccess: null,
            loading: false,
            jobDeleteError: action.payload,
          }
          break
          case GET_DATA :
            state = {
              ...state,
              loading: true,
              jobListError: null
            }
            break
            case GET_SEARCH_DATA : state = {
              ...state,
              loading: true,
              jobListError: null
            }
            break

            case GET_JOBS_BY_LIST:
              state={
                ...state,
                loading:true,
                jobs:null,
                jobsFailed:null
              }
              break

              case GET_JOBS_BY_LIST_SUCCESS:
                state={
                  ...state,
                  loading:false,
                  jobs:action.payload,
                  jobsFailed:null
                }
                break

                case GET_JOBS_BY_LIST_FAILED:
                  state={
                    ...state,
                    loading:false,
                    jobs:null,
                    jobsFailed:action.payload
                  }
                  break

                  case GET_JOBS_BY_SEARCH:
                    state={
                      ...state,
                      loading:true,
                      jobs:null,
                      jobsFailed:null
                    }
                    break
      
                    case GET_JOBS_BY_SEARCH_SUCCESS:
                      state={
                        ...state,
                        loading:false,
                        jobs:action.payload,
                        jobsFailed:null
                      }
                      break
      
                      case GET_JOBS_BY_SEARCH_FAILED:
                        state={
                          ...state,
                          loading:false,
                          jobs:null,
                          jobsFailed:action.payload
                        }
                        break
                        case GET_JOBS_BY_FILTER:
                          state={
                            ...state,
                            loading:true,
                            jobs:null,
                            jobsFailed:null
                          }
                          break
            
                          case GET_JOBS_BY_FILTER_SUCCESS:
                            state={
                              ...state,
                              loading:false,
                              jobs:action.payload,
                              jobsFailed:null
                            }
                            break
            
                            case GET_JOBS_BY_FILTER_FAILED:
                              state={
                                ...state,
                                loading:false,
                                jobs:null,
                                jobsFailed:action.payload
                              }
                              break
    default:
      state = { ...state }
      break
  }
  return state
}

export default getJobList
